import instance from './index'

const api = process.env.VUE_APP_BASE_API

/**
 *  http 请求
 * */

export const login = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/login', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const userInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/user/info', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const menuNav = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/menu/nav', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const userList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/user/listEnterpriseUser', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const roleUList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/role/ulist', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const editUser = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/user/editEnterpriseUser', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const addUser = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/user/addEnterpriseUser', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const deleteUser = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/user/deleteEnterpriseUser', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const restpwdUser = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/user/restpwd', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const reviewStatus = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/review/status', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const userUserInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/role/ulist', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

/**
 * 角色
 * */

export const roleList = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/role/list', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const roleInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/role/info/'+params, )
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const menuTree = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/menu/tree', {params: params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const roleAdd = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/role/add', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const roleEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/role/edit', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const roleDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/role/delete', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}



/***
 *
 *  企业基本信息
 *
 * */

export const departmentInfo = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/department/info', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const departmentUpdate = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/department/update', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const dataSourceSave = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/dataSource/save', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const dataSourceEdit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/dataSource/edit', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const reviewSubmit = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/review/submit', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const reviewAuto = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/review/auto', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const dataSourceInfo = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/dataSource/info/'+params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const processListUser = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/process/listUser', {params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const regionListByParent = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/sys/region/listByParent', {params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const processModule = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/processModule/listUser',{params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const reviewCheck = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/review/check', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const reviewPage = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/review/page', {params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const dataList = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/data/list', params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

//   审核管理

export const processListAdmin = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/process/listAdmin', {params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const processModuleAdmin = params => {
    return new Promise((resolve, reject) => {
        instance.get(api + '/processModule/listAdmin',{params:params})
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const dataSourceInfoAdmin = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/dataSource/infoAdmin',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const commenthistorySave = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/commenthistory/save',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}


export const commenthistoryList = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/commenthistory/list',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const commenthistoryListUser = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/commenthistory/listUser',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}

export const commenthistoryReplay = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/commenthistory/replay',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
export const commenthistoryDelete = params => {
    return new Promise((resolve, reject) => {
        instance.post(api + '/sys/commenthistory/delete',params)
            .then(response => {
                if (response) {
                    resolve(response.data)
                } else {
                    resolve({})
                }
            })
            .catch(error => {
                reject(error)
            })
    })
}
